import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Documents from "./Document/Documents";
import ChatLandingPage from "./Chat/ChatLandingPage";
import SavedChats from "./Chat/SavedChats";
import SupportCallLandingPage from "./SupportCall/SupportCallLandingPage";
import DashboardLandingPage from "./Dashboard/DashboardLandingPage";
import ResearchLandingPage from "./Research/ResearchLandingPage";
import Login from "./Account/Login";
import BridgeValidationPage from "./Account/BridgeValidationPage";
import SupportCallAnalysis from "./SupportCall/SupportCallAnalysis";
import GuideLandingPage from "./Guide/GuideLandingPage";
import Webinar from "./Webinar/WebinarLandingPage";
import WebinarAnalysis from "./Webinar/WebinarAnalysis";
import Os165LandingPage from "./Document/OS165LandingPage";
import ImportantLinksLandingPage from "./Document/IMPLinks";
import NotebookLMLandingPage from "./Document/NotebookLM";
import CompanyDirectoryLandingPage from "./Company Directory/CompanyDirectory";
import CDEmployeeLandingPage from "./Company Directory/Employee";
import CDDepartmentLandingPage from "./Company Directory/Department";
import CDOfficeLandingPage from "./Company Directory/Office";
import CDAdminLandingPage from "./Company Directory/Admin";

  
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />}></Route>
        <Route path="/bridge" element={<BridgeValidationPage />} />
        <Route path="/chat" element={<ChatLandingPage />}></Route>
        <Route path="/dashboard" element={<DashboardLandingPage />}></Route>
        <Route path="/documents" element={<Documents />}></Route>
        <Route path="/saved" element={<SavedChats />}></Route>
        <Route path="/supportcall" element={<SupportCallLandingPage />}></Route>
        <Route path="/research" element={<ResearchLandingPage />}></Route>
        <Route path="/supportcallanalysis/:id" element={<SupportCallAnalysis />}></Route>
        <Route path="/chat/:conversationId" element={<ChatLandingPage />} />
        <Route path="/guide" element={<GuideLandingPage />}></Route>
        <Route path="/webinar" element={<Webinar/>}></Route>
        <Route path="/webinaranalysis" element={<WebinarAnalysis/>}></Route>
        <Route path="/os165" element={<Os165LandingPage/>}></Route>
        <Route path="links" element={<ImportantLinksLandingPage/>}></Route>
        <Route path="/notebooklm" element={<NotebookLMLandingPage/>}></Route>
        <Route path="/companydirectory" element={<CompanyDirectoryLandingPage/>}></Route>
        <Route path="/employee" element={<CDEmployeeLandingPage/>}></Route>
        <Route path="/department" element={<CDDepartmentLandingPage/>}></Route>
        <Route path="/office" element={<CDOfficeLandingPage/>}></Route>
        <Route path="/admin" element={<CDAdminLandingPage/>}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
